module.exports = __webpack_public_path__ + "static/media/soham_gupte.993b1b34.jpg";